import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { PaginatorStatus } from 'src/app/components/generics/data-table/data-table.component';
import { Broker } from 'src/app/models/broker.model';
import { ErrorResponse } from 'src/app/models/error.model';
import { Office } from 'src/app/models/office.model';
import { BrokersService } from 'src/app/services/brokers.service';
import { OfficesService } from 'src/app/services/offices.service';
import { UtilsService } from 'src/app/services/utils.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-broker-selector-dialog',
    templateUrl: './broker-selector-dialog.component.html',
    styleUrls: ['./broker-selector-dialog.component.scss']
})
export class BrokerSelectorDialogComponent implements OnInit {

    filtersFG = new UntypedFormGroup({
        id: new UntypedFormControl(undefined),
        cuit: new UntypedFormControl(undefined),
        oficina: new UntypedFormControl(undefined),
    });

    paginatorStatus: PaginatorStatus = {
        page: 0,
        itemsPerPage: 30,
        totalElementCount: 0
    };

    brokers?: Broker[];
    offices?: Office[];

    constructor(
        private officesService: OfficesService,
        private brokersService: BrokersService,
        private authService: AuthService,
        private dialogRef: MatDialogRef<BrokerSelectorDialogComponent>,
        public utilsService: UtilsService,
    ) { }

    ngOnInit(): void {
        const user = this.authService.getUser();
        if (user.tipo === 'OFICINA' && user.oficina) {
            this.offices = [user.oficina];
            this.filtersFG.controls.oficina.setValue(user.oficina);
        } else {
            this.getOffices();
        }
        this.getBrokers();
    }

    cerrarDialogo(broker?: Broker | undefined) {
      this.dialogRef.close(broker);
    }

    getOffices() {
        this.officesService.getOffices(0, 100000, [], {}).subscribe(response => {
            this.offices = response.body;
        }, (error: ErrorResponse) => this.utilsService.alert('Error buscando oficina', error.error?.descripcion));
    }

    getBrokers() {
        const value = this.filtersFG.getRawValue();
        const filters: any = {};
        if (value.oficina?.id)
            filters['id-oficina'] = value.oficina.id;
        if (value.id)
            filters.id = value.id;
        if (value.cuit)
            filters.cuit = value.cuit;
        this.brokers = undefined;
        this.brokersService.getBrokers(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage, [], filters).subscribe(response => {
            this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
            this.brokers = response.body;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener agentes', error.error?.descripcion));
    }

}
